export default "__VITE_ASSET__DfDRkEoz__"